import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import SuspicionTableDto from '../dto/SuspicionTableDto';

class SuspicionTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'suspicionTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<SuspicionTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, SuspicionTableDto)))
				.catch(reject);
		});
	}
}

export default new SuspicionTableService();
